// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon-close[data-v-6276212d]{float:right;font-size:xx-small;font-weight:300;margin-top:2px}", ""]);
// Exports
module.exports = exports;
